export default {
  account: "account name",
  password:"password",
  verifCode:"verification code",
  changeVerifCode: "Click to switch verification code",
  login:"Login",
  accountRequired:"Please enter your account name",
  passwordRequired:"Please enter the account password",
  verifCodeRequired:"Please enter the verification code",
  verifCodeError: "Verification code error"
}


// WEBPACK FOOTER //
// ./src/views/login/login.en.js